import React from 'react';

import { CustomSwitch } from 'src/presentation/components/agent_desktop_components';
import { FieldContained } from '@ad-scripts/presentation/components/common/textarea_field';
import { LabelContainer, ThenContainer } from '../RuleLayout';
import PickOmit from './PickOmit';
import Pivot from './Pivot';
import { Row } from 'src/presentation/components/pages/sidekick/threads/components/Layout';
import SelectAction from './SelectAction';
import { StyledIfLabel } from 'src/presentation/components/pages/sidekick/threads/components/SidePanel/Components/Rule/ConditionOperator';
import { ThenTypes, thenOptions } from './ThenConstants';
import useChangeThen from './hooks/useChangeThen';

type ThenProps = {
  attr: string;
  disabled: boolean;
  isFilterByRule: boolean;
};

const Then = ({ attr, disabled, isFilterByRule }: ThenProps) => {
  return (
    <Row>
      <FieldContained
        attr={attr}
        control={
          <>
            <LabelContainer>
              <StyledIfLabel>Then</StyledIfLabel>
            </LabelContainer>
            <ThenContainer data-aid="then-container">
              {isFilterByRule ? (
                <PickOmit attr={attr} disabled={disabled} />
              ) : (
                <PivotOrActionControl attr={attr} disabled={disabled} />
              )}
            </ThenContainer>
          </>
        }
      />
    </Row>
  );
};

const PivotOrActionControl = ({ attr, disabled }) => {
  const { actionOptions, actionChange, thenType, handleSwitch, pivotChange } = useChangeThen(attr);

  return (
    <>
      <div style={{ maxWidth: '160px' }}>
        <CustomSwitch
          data-aid="then-switch"
          option1={thenOptions[0]}
          option2={thenOptions[1]}
          onSelectSwitch={handleSwitch}
          value={thenType}
          disabled={disabled}
        />
      </div>
      <>
        {thenType === ThenTypes.anonymousModule && (
          <SelectAction
            attr={`${attr}.anonymousModule`}
            disabled={disabled}
            options={actionOptions}
            onChange={actionChange}
          />
        )}
        {thenType === ThenTypes.pivotFlowID && <Pivot attr={`${attr}.pivotFlowID`} onChange={pivotChange} />}
      </>
    </>
  );
};

export default Then;
